const INDEX_ITEMS = [
  { tag: '动作', label: '动作冒险', count: '586部' },
  { tag: '喜剧', label: '喜剧搞笑', count: '432部' },
  { tag: '爱情', label: '爱情浪漫', count: '521部' },
  { tag: '悬疑', label: '悬疑推理', count: '398部' },
  { tag: '科幻', label: '科幻奇幻', count: '315部' },
  { tag: '古装', label: '古装历史', count: '467部' },
  { tag: '动画', label: '动漫番剧', count: '623部' },
  { tag: '纪录', label: '纪录片', count: '289部' },
];

export default function Index() {
  return (
    <section id="index" className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-[1280px] mx-auto">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-950">影视分类索引</h2>
          <p className="mt-2 text-sm text-foreground-600">按类型快速浏览，精准找到你想看的内容</p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-4">
          {INDEX_ITEMS.map((item, idx) => (
            <a
              key={idx}
              href="#cards"
              onClick={(e) => {
                e.preventDefault();
                document.querySelector('#cards')?.scrollIntoView({ behavior: 'smooth' });
              }}
              className="group bg-background-50 rounded-xl p-5 border border-background-200/70 hover:border-primary-200/50 hover:bg-primary-50/30 transition-all duration-300 flex flex-col items-center text-center cursor-pointer"
            >
              <div className="w-14 h-14 rounded-xl bg-secondary-100 flex items-center justify-center mb-3 group-hover:bg-primary-100 transition-colors duration-300">
                <i className="ri-movie-2-line text-xl text-secondary-600 group-hover:text-primary-600 transition-colors duration-300"></i>
              </div>
              <h3 className="font-heading text-base text-foreground-900 mb-1">{item.label}</h3>
              <span className="text-xs text-foreground-500 bg-background-100 px-3 py-1 rounded-full whitespace-nowrap">{item.count}</span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}